import "../scss/page.scss";

import "../scss/people.scss";

import "./scripts/dm-marketing/navbar.js";